// removed by extract-text-webpack-plugin
module.exports = {"loginButton":"ResetPW--loginButton--1JoSlor7","note":"ResetPW--note--1pt-L2zk"};


//////////////////
// WEBPACK FOOTER
// ./src/App/auth/Views/ResetPW.css
// module id = 1314
// module chunks = 2